<template>
  <el-popover 
    :width="250" 
    trigger="click" 
    placement="bottom-start">
    <div>
      <el-row class="guest-row">
        <el-col :span="8">
          <span>{{ $t("GUESTSCOMPONENTS.ROOMNUM") }}</span>
        </el-col>
        <el-col :span="12">
          <el-input-number
            size="small"
            v-model.number="roomNum"
            @change="guestChangeRoom"
            :min="1"
            :max="maxRoomNum"
            :step-strictly="true"
            :label="$t('GUESTSCOMPONENTS.ROOMNUM')"
          ></el-input-number>
        </el-col>
      </el-row>
      <el-row class="guest-row">
        <el-col :span="8">
          <span>{{ $t("GUESTSCOMPONENTS.ADULTNUM") }}</span>
        </el-col>
        <el-col :span="12">
          <el-input-number
            size="small"
            v-model.number="adultNum"
            @change="guestChangeAdult"
            :min="1"
            :max="maxAdultNum"
            :disabled="isEditGuestCount"
            :step-strictly="true"
            :label="$t('GUESTSCOMPONENTS.ADULTNUM')"
          ></el-input-number>
        </el-col>
      </el-row>
    </div>
    
    <template #reference>
      <div>
        <el-input
          v-if="!isDisplayText"
          :placeholder="$t('SEARCH.GUESTS')"
          readonly
          v-model="comReturnParent"
        >
          <template #prefix>
            <svg-icon
              v-show="showIcon"
              icon-class="guest"
            ></svg-icon>
          </template>
        </el-input>
        <div v-else>
          <p class="numselectadult">
            <span>{{ $t("GUESTSCOMPONENTS.ROOMNUM") }}</span>
            <span class="lt-color">{{ roomNum }}</span>
          </p>
          <p class="numselectadult">
            <span>{{ $t("GUESTSCOMPONENTS.ADULTNUM") }}</span>
            <span class="lt-color">{{ adultNum }}</span>
          </p>
        </div>
      </div>
    </template>
  </el-popover>
</template>

<script>
import { getCurrentInstance } from 'vue';

export default {
  name: "Guests",
  components: {},
  props: {
    showIcon: { default: true },
    maxRoom: { default: 1 },
    maxAdultRoom: { default: 1 },
    roomCount: { default: 1 },
    guestCount: { default: 1 },
    isDisplayText: {
      type: Boolean,
      default: false,
    },
    isEditGuestCount: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      roomNum: Number(this.roomCount) || 1,
      adultNum: Number(this.guestCount) || 1,
      maxAdultNum: 10,
      maxRoomNum: 10,
      maxAdultNumRoom: 1,
      objBaseInfo: {}, // 存储全局属性
    };
  },
  watch: {
    maxRoom(val) {
      this.maxRoomNum = val;
    },
    maxAdultRoom(val) {
      this.maxAdultNumRoom = val;
      this.maxAdultNum = val * this.roomNum;
    },
    guestCount(val) {
      this.adultNum = Number(val) || 0;
    },
    roomCount(val) {
      this.roomNum = Number(val) || 0;
      this.guestChangeRoom();
    },
  },
  methods: {
    guestChangeRoom() {
      this.setMaxAdultNum();
      this.setInputGuest();
    },
    guestChangeAdult() {
      this.setInputGuest();
    },
    //计算人数最大值
    setMaxAdultNum() {
      this.maxAdultNum = this.roomNum * this.maxAdultNumRoom;
      if (this.maxAdultNum < this.adultNum) {
        this.adultNum = this.maxAdultNum;
      }
    },
    //设置文本框的值
    setInputGuest() {
      // 输出参数
      this.$emit("setRoomNum", this.roomNum);
      this.$emit("setAdultNum", this.adultNum);
    },
  },
  mounted() {
    // 获取全局属性
    const instance = getCurrentInstance();
    if (instance) {
      this.objBaseInfo = instance.appContext.config.globalProperties.$objBaseInfo || {};
    }
    
    if (
      this.objBaseInfo != undefined &&
      this.objBaseInfo.maxRoom != undefined
    ) {
      this.maxRoomNum = this.objBaseInfo.maxRoom;
      this.maxAdultNumRoom = this.objBaseInfo.maxAdult;
    } else {
      this.maxRoomNum = this.maxRoom;
    }
    this.setMaxAdultNum();
    this.setInputGuest();
  },
  computed: {
    comReturnParent: function () {
      return `${this.roomNum} ${this.$t("GUESTSCOMPONENTS.ROOM")}，${
        this.adultNum
      } ${this.$t("GUESTSCOMPONENTS.ADULT")}`;
    },
  },
};
</script>

<style lang="stylus" scoped>
@media screen and (max-width: 960px) {
  .guest-row {
    font-size: 1.2rem;
  }

  .numselectadult{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    span:first-child{
      padding-right: 0.3rem;
    }
  }

  .lt-color {
    color: $btn-bg-color;
  }
}
.guest-row{
    margin-bottom: 1rem;
    line-height: 4rem;
}
.el-tooltip__trigger :deep(.el-input__wrapper) {
  height: 5rem;
  line-height: 5rem;
  background-color: #e7e9ea;
}
</style>